/**
 * This is the entry file for webpackAdminModuleConfig.js
 */


// Nette forms
import netteForms from 'nette-forms';
window.Nette = netteForms;
netteForms.initOnLoad();


// Application
import './js/netteFormsExtension.js';
import './js/spinner.js';
import './js/flashMessenger.js';
import './js/general.js';
import './js/frontModule/parking/loadTicket.js';
import './js/frontModule/parking/ticket.js';
